import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { StepsModule } from 'primeng/steps';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { ChartModule } from 'primeng/chart';
import { InputTextModule } from 'primeng/inputtext';

import { DropdownFilterComponent } from '../components/dropdown-filter-component/dropdown-filter.component';
import { LocationFilterComponent } from '../components/location-filter-component/location-filter.component';
import { CheckBoxFilterComponent } from '../components/checkbox-filter-component/checkbox-filter.component';
import { MultiSelectFilterComponent } from '../components/multiselect-filter-component/multiselect-filter.component';
import { QuickViewCardComponent } from '../components/quick-view-card-component/quick-view-card.component';
import { DetailViewCardComponent } from '../components/detail-view-card-component/detail-view-card.component';
import { DisplaySegmentComponent } from '../routes/search-cars-component/display-segment-component/display-segment.component';
import { NewBuildsLandingPageModule } from '../components/new-builds/new-builds-landing-page.module';

@NgModule({
  declarations: [
    DropdownFilterComponent,
    CheckBoxFilterComponent,
    LocationFilterComponent,
    MultiSelectFilterComponent,
    QuickViewCardComponent,
    DetailViewCardComponent,
    DisplaySegmentComponent,
  ],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    StepsModule,
    AutoCompleteModule,
    CheckboxModule,
    MultiSelectModule,
    DialogModule,
    DropdownModule,
    TooltipModule,
    ChartModule,
    InputTextModule,
    NewBuildsLandingPageModule,
  ],

  exports: [
    DropdownFilterComponent,
    CheckBoxFilterComponent,
    LocationFilterComponent,
    MultiSelectFilterComponent,
    QuickViewCardComponent,
    DetailViewCardComponent,
    DisplaySegmentComponent,
  ],
})
export class ComponentsModule {}
